"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterInfoPopup = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const questionMark_svg_1 = __importDefault(require("../../../assets/icons/questionMark.svg"));
const S = __importStar(require("./SessionFilters.style"));
const InfoPopup = (props) => {
    return react_1.default.createElement(S.InfoPopup, Object.assign({}, props));
};
const FilterInfoPopup = ({ filterTranslationLabel }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    return (react_1.default.createElement(InfoPopup, { trigger: react_1.default.createElement(S.InfoButton, null,
            react_1.default.createElement(S.InfoIcon, { src: questionMark_svg_1.default })), position: isMobile ? "left center" : "right center", repositionOnResize: true, keepTooltipInside: true, arrow: false, on: ["hover", "focus"], offsetX: isMobile ? 5 : 10 },
        react_1.default.createElement(S.Info, null, t(filterTranslationLabel))));
};
exports.FilterInfoPopup = FilterInfoPopup;
